import React, { useCallback, useState } from "react";
import useApi from "./useApi";

export default function useVersion() {
  const api = useApi();
  const [version, setVersion] = useState<string | null>(null);
  const [showReloadModal, setShowReloadModal] = useState(false);

  function resetModal() {
    setShowReloadModal(false);
  }
  const getVersion = useCallback(async () => {
    try {
      const response = await api.messaging.get("version");
      // If the messaging API is down or auth-expired, don't redirect — just skip
      // the version check silently. The admin session is managed independently.
      if (!response.ok) return;
      const newVersion = await response.json();
      if (version == null) {
        setVersion(newVersion);
      } else if (version != newVersion) {
        setShowReloadModal(true);
      }
    } catch {
      // Network error (API down) — swallow silently, retry on next interval
    }
  }, [api.messaging, version]);

  React.useEffect(() => {
    if (version == null) {
      getVersion();
    }
    //periodically ping the server to check for a new version
    const interval = setInterval(getVersion, 1000 * 30);
    return () => clearInterval(interval);
  }, [api.messaging, getVersion, version]);

  return { showReloadModal, resetModal, version };
}
